import type { ISODateTimeString } from '@gat-ship/types'
import { Temporal } from '@js-temporal/polyfill'

/** Get the current timezone ID. */
export function getCurrentTimeZoneId(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

/** Set the anchor time for the date. */
export function toAnchorTime(
  date: Temporal.ZonedDateTime,
  anchorTime: 'midnight' | 'noon' | 'now',
  timeZone: string
) {
  if (anchorTime === 'midnight') {
    return date.with({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0,
      microsecond: 0,
      nanosecond: 0
    })
  }
  if (anchorTime === 'noon') {
    return date.with({
      hour: 12,
      minute: 0,
      second: 0,
      millisecond: 0,
      microsecond: 0,
      nanosecond: 0
    })
  }
  if (anchorTime === 'now') {
    const now = Temporal.Now.zonedDateTimeISO(timeZone)
    return date.with({
      hour: now.hour,
      minute: now.minute,
      second: now.second,
      millisecond: now.millisecond,
      microsecond: now.microsecond,
      nanosecond: now.nanosecond
    })
  }
  return date
}

export function isoDateTimeToZonedDateTimeWithAnchorTime(
  value: ISODateTimeString,
  options?: {
    anchorTime?: 'midnight' | 'noon' | 'now'
    timeZone?: string
  }
) {
  const date = Temporal.Instant.from(value).toZonedDateTimeISO(
    options?.timeZone || getCurrentTimeZoneId()
  )
  if (options?.anchorTime) {
    return toAnchorTime(date, options.anchorTime, options.timeZone || getCurrentTimeZoneId())
  }
  return date
}

export function formatDate(date: Temporal.ZonedDateTime, locale: string, dateOnly = false) {
  return date
    .toLocaleString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: dateOnly ? undefined : '2-digit',
      minute: dateOnly ? undefined : '2-digit'
    })
    .replace(',', '')
}

// export function toFutureDate(date: Temporal.ZonedDateTime) {
//   return date.with({
//     year: date.year + 1
//   })
// }
